import Vue from 'vue'

// Register a global custom directive called `v-focus`
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el, binding) {
    // Focus the element
    if (binding.value === true) {
      el.focus()
    }
  }
})
